import React, { useEffect, useState } from 'react'
import { Trophy, Medal } from 'lucide-react'
import { fetchRank } from '../../lib/ranking.js'
import { tr, useLang } from '../../games/lib/lang.js'

export function RankingView({ session }) {
  const [lang] = useLang()
  const num = (value) => Number(value || 0).toLocaleString(lang === 'en' ? 'en-US' : 'es-MX')
  const [board, setBoard] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancel = false
    fetchRank(session)
      .then((data) => {
        if (!cancel) setBoard(data)
      })
      .catch(() => {
        if (!cancel) setFailed(true)
      })
    return () => {
      cancel = true
    }
  }, [session])

  const leaders = board?.leaders || []
  const podium = [leaders[1], leaders[0], leaders[2]]

  return (
    <div className="p-4 flex flex-col min-h-[85vh] max-w-md mx-auto space-y-4">
      <div>
        <h2 className="text-xl font-black text-white flex items-center gap-2">
          <Trophy size={20} className="text-yellow-400" />
          <span>{tr(lang, 'Ranking global', 'Global ranking')}</span>
        </h2>
        <p className="text-xs text-slate-400">
          {board?.rank
            ? tr(lang, `Tu puesto es #${board.rank} con ${num(board.score)} pts`, `Your rank is #${board.rank} with ${num(board.score)} pts`)
            : tr(lang, 'Juega una partida para entrar en la tabla', 'Play a game to enter the table')}
        </p>
      </div>

      {failed && (
        <p className="text-sm text-slate-400">{tr(lang, 'El ranking no cargó. Tu puntuación sigue guardada en este dispositivo.', 'The ranking didn’t load. Your score is still saved on this device.')}</p>
      )}

      {!failed && board && leaders.length === 0 && (
        <p className="text-sm text-slate-300">{tr(lang, 'Todavía no hay puntuaciones. La primera partida abre el ranking.', 'No scores yet. The first game opens the ranking.')}</p>
      )}

      {leaders.length >= 3 && (
        <div className="grid grid-cols-3 gap-2 pt-4 pb-2 items-end">
          {podium.map((item, index) => (
            <div
              key={`podium-${index}`}
              className={`p-3 rounded-2xl border flex flex-col items-center text-center ${
                item.rank === 1
                  ? 'bg-gradient-to-b from-amber-950/60 via-slate-900 to-slate-900 border-amber-500/50 -translate-y-2'
                  : 'bg-gradient-to-b from-slate-800 to-slate-900 border-slate-700'
              } ${item.you ? 'ring-1 ring-cyan-400/70' : ''}`}
            >
              {item.rank === 1 ? <Medal size={18} className="text-yellow-400" /> : <span className="text-xs font-black text-slate-300">#{item.rank}</span>}
              <span className="mt-1 text-[11px] font-bold text-white truncate max-w-full">{item.you ? tr(lang, 'Tú', 'You') : item.name}</span>
              <span className="text-[10px] text-cyan-300 font-extrabold">{num(item.bp)}</span>
            </div>
          ))}
        </div>
      )}

      <div className="space-y-2 flex-1">
        {leaders.map((item, index) => (
          <div
            key={`row-${item.rank}-${index}`}
            className={`p-3 rounded-xl border flex items-center justify-between ${
              item.you
                ? 'bg-purple-950/50 border-purple-500/60'
                : 'bg-slate-900/70 border-slate-800'
            }`}
          >
            <div className="flex items-center gap-3">
              <span className="text-xs font-black w-8 text-center text-slate-300">#{item.rank}</span>
              <span className="text-xs font-bold text-white">{item.you ? tr(lang, 'Tú', 'You') : item.name}</span>
            </div>
            <div className="text-xs font-black text-white">{num(item.bp)} pts</div>
          </div>
        ))}
      </div>
    </div>
  )
}
